export const EXCEL_CONFIRM_ROUTE_MAP = {
    '/nedis/jinryoweb/bdjrnaeyeokdetaillistA.do': true,
    '/nedis/oesangweb/bdTrmsHumanResource.do': true,
    '/nedis/oesangweb/bdTrmsHumanResource_nurse.do': true,
    '/nedis/oesangweb/bdTrmsHumanResourceSupport.do': true,
    '/nedis/oesangweb/bdTrmsHumanResourceSpcial.do': true,
    '/nedis/oesangweb/bdTrmsHumanResourceEtc.do': true,
    '/nedis/oesangweb/bdTrmsHumanNurse.do': true,
    '/nedis/oesangbiz/ecshgHnfEdcTraingRsltList.do': true,
    '/nedis/oesangbiz/ecshgHnfEdcTraingRsltTrnList.do': true,
    '/nedis/oesangbiz/opercmitOperrsltTrnList.do': true,
    '/nedis/oesangbiz/trnThesis.do': true,
    '/nedis/oesangbiz/trnAbstPst.do': true,
};